var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("GrmBtn", { attrs: { color: "gray" }, on: { click: _vm.onBack } }, [
        _vm._v(_vm._s(_vm.$t("testBank.goBack"))),
      ]),
      _c(
        "div",
        {
          staticClass:
            "mt-4 -mx-3 py-8 px-10 bg-gray-100 lg:mt-10 lg:-mx-10 lg:px10",
        },
        [
          _c("div", { staticClass: "flex flex-col gap-y-6" }, [
            _c("div", { staticClass: "flex gap-x-4" }, [
              _c(
                "div",
                { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                    },
                    [_vm._v(_vm._s(_vm.$t("setting.name.title")))]
                  ),
                  _c(
                    "p",
                    { staticClass: "rounded-lg py-3 px-4 bg-white text-sm" },
                    [_vm._v(_vm._s(_vm.testbankExamHistory.examTitle))]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.style")))]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "GrmBtn",
                        {
                          attrs: {
                            color:
                              _vm.testbankExamHistory.examType === "QUIZ"
                                ? "purple"
                                : "green",
                            hoverColor: "none",
                            disabled: "",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.testbankExamHistory.examType === "QUIZ"
                                ? _vm.$t("testBank.write")
                                : _vm.$t("testBank.survey")
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "flex gap-x-4" }, [
              _c(
                "div",
                { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                    },
                    [_vm._v(_vm._s(_vm.$t("common.name")))]
                  ),
                  _c("p", { staticClass: "text-sm break-words" }, [
                    _vm._v(_vm._s(_vm.testbankExamHistoryUser.username)),
                  ]),
                ]
              ),
              _vm.testbankExamHistory.examType === "QUIZ"
                ? _c(
                    "div",
                    { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                        },
                        [_vm._v(_vm._s(_vm.$t("testBank.score")))]
                      ),
                      _c("p", { staticClass: "text-sm break-words" }, [
                        _vm._v(
                          _vm._s(_vm.testbankExamHistoryUser.examScore) +
                            _vm._s(_vm.$t("exam.question.point"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flex gap-x-4" }, [
              _c(
                "div",
                { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.limit")))]
                  ),
                  _c("p", { staticClass: "text-sm break-words" }, [
                    _vm._v(_vm._s(_vm.examDuration(_vm.testbankExamHistory))),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "min-w-0 flex-1 flex flex-col gap-y-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6",
                    },
                    [_vm._v(_vm._s(_vm.$t("testBank.period")))]
                  ),
                  _c("p", { staticClass: "text-sm break-words" }, [
                    _vm._v(
                      _vm._s(_vm.testbankExamHistory.beginDate) +
                        " ~ " +
                        _vm._s(_vm.testbankExamHistory.endDate)
                    ),
                  ]),
                ]
              ),
            ]),
            _vm.testbankExamHistory.examType === "QUIZ"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "border-t border-gray-300 pt-6 flex flex-col items-center",
                  },
                  [
                    _c("p", { staticClass: "font-bold" }, [
                      _vm._v(_vm._s(_vm.$t("testBank.answerTable"))),
                    ]),
                    _c("TestbankResultCorrectTable", {
                      staticClass: "mt-4",
                      attrs: { questionList: _vm.userQuestionList },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._l(_vm.userQuestionList, function (userQuestion, i) {
        return _c(
          userQuestion.questionType === "CHOICE"
            ? "TestbankHistoryQuestionChoice"
            : "TestbankHistoryQuestionSubjective",
          {
            key: userQuestion.questionId,
            tag: "component",
            attrs: {
              index: i,
              question: userQuestion,
              examTypeQuiz: _vm.testbankExamHistory.examType === "QUIZ",
            },
          }
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }